// eslint-disable-next-line
import type { Account } from '../types/user';

export const account: Account = {
  displayName: 'Jaydon Frankie',
  email: 'demo@minimals.cc',
  photoURL: '/assets/images/avatars/avatar_12.jpg',
  role: 'Partner',
};
